<template>
  <div class="guests container-full">
    <div class="container">
      <h3>2020嘉宾阵容</h3>
      <div class="swiper-container " id="guestsSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide"  v-for="(val, key) in res" :key="key">
            <div class="sc">
              <div class="name">{{ val.title }}</div>
              <div class="job">
                <span>{{ val.about }}</span>
              </div>
              <div class="detail">{{ val.describe }}</div>
              <a :href="val.link"><img :src="val.url"/></a>
            </div>
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="" id="guests-pagination"></div>
        <!-- 如果需要导航按钮 -->
        <div class="" id="guests-prev"></div>
        <div class="" id="guests-next"></div>
        <!-- 如果需要滚动条 -->
        <!-- <div class="swiper-scrollbar"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  name: "banner",
  props: ["res"],
  data() {
    return {
      guestsSwiper: "",
      guestsSwiperOption: {},
      bannerList: [
        {
          url: require("@/assets/img/guests/1.png"),
          link: "",
          name: "龚琳娜",
          job: "演唱家",
          detail:
            "中国新艺术音乐歌唱家、中国新艺术音乐创始人；代表作《孔雀飞来》走生命的路》《静夜思》《走西口》《忐忑》等。"
        },
        {
          url: require("@/assets/img/guests/2.png"),
          link: "",
          name: "单霁翔",
          job: "史航",
          detail:
            "故宫博物院原院长、高级建筑师、注册城市规划师；曾任中华人民共和国文化和旅游部党组成员（副部长级）。"
        },
        {
          url: require("@/assets/img/guests/3.png"),
          link: "",
          name: "史航",
          job: "编剧",
          detail:
            "知名编剧、影评人、节目策划人、作家；代表作《大漠豪情》《铜牙铁齿纪晓岚1》《射雕英雄传》等。"
        }
      ]
    };
  },
  created() {},
  methods: {
    SwiperReady() {
      let screenWidth = document.body.clientWidth;
      if (screenWidth < 765) {
        this.guestsSwiperOption = {
          
          slidesPerView: "auto",
          centeredSlides: true,
          watchSlidesProgress: true,
          loop: true,
          pagination: {
            el: "#guests-pagination"
          },
          navigation: {
            nextEl: "#guests-next",
            prevEl: "#guests-prev"
          }
        };
      } else {
        this.guestsSwiperOption = {
          slidesPerView: "auto",
          centeredSlides: true,
          watchSlidesProgress: true,
          loop: true,
          pagination: {
            el: "#guests-pagination"
          },
          navigation: {
            nextEl: "#guests-next",
            prevEl: "#guests-prev"
          }
        };
      }
      if (this.guestsSwiper) {
        this.guestsSwiper.destroy();
        this.$nextTick(() => {
          this.guestsSwiper = new Swiper(
            "#guestsSwiper.swiper-container",
            this.guestsSwiperOption
          );
        });
      } else {
        this.$nextTick(() => {
          this.guestsSwiper = new Swiper(
            "#guestsSwiper.swiper-container",
            this.guestsSwiperOption
          );
        });
      }
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.SwiperReady();
      })();
    };
    //
    this.$nextTick(() => {
      setTimeout(() => {
        this.SwiperReady();
      }, 2000);
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.sc{
  display: flex;
  height: 100%;
 flex-flow: column;
 justify-content:space-around;
}
.guests {
  height: 1080px;
  background-image: url("../../assets/img/guestsbg.png");
  background-repeat: no-repeat;
  background-position: center center;
  .container {
    height: 100%;
  }
  h3 {
    font-size: 24px;
    font-weight: 600;
    line-height: 57px;
    color: rgba(255, 255, 255, 1);
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.29);
    opacity: 1;
    text-align: center;
    margin: 60px 0 60px;
  }
  .swiper-container {
     padding-bottom: 160px;
    height: auto;
    @btn-size: 92px;
    #guests-prev,
    #guests-next {
      width: @btn-size;
      height: @btn-size;
      background-image: url("../../assets/img/pn.png");
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
      bottom: 40px;
      top: auto !important;
      position: absolute;
      cursor: pointer;
    }
    #guests-prev {
      left: 50px;
    }
    #guests-next {
      right: 50px;
      transform: rotate(180deg);
    }
    #guests-pagination {
      bottom: 70px;
      height: 17px !important;
      position: absolute;
      width: 100%;
      left: 0;
      text-align: center;
     
    }

    .swiper-slide {
      width: 460px;
      border-radius: 15px;
      &.swiper-slide-active {
        background: #fff;
      }
      text-align: center;
      padding: 35px;
      height: 770px;
      .name {
        font-size: 31px;
        font-weight: 600;
        line-height: 37px;
        color: rgba(0, 0, 0, 1);
        opacity: 1;
        margin-top: 35px;
      }
      .job {
        font-size: 24px;
        font-weight: 400;
        line-height: 37px;
        color: rgba(0, 0, 0, 1);
        opacity: 1;
        margin-top: 10px;
      }
      .detail {
        text-align: justify;
        margin-top: 60px;
        font-size: 18px;
        font-weight: 400;
        line-height: 26px;
        color: rgba(0, 0, 0, 1);
        opacity: 1;
        height: 190px;
      }
      img {
        width: 214px;
        height: 287px;
      }
    }
  }
}




@media (max-width: 765px) {
  #guests-prev {
    left: 0px !important;
  }
  #guests-next {
    right: 0px !important;
  }
  #guests-prev,
  #guests-next {
    bottom: 20px !important;
  }
  .swiper-slide{
    width:50% !important;
  }

  .guests {
  height: auto;
  background-image: url("../../assets/img/guestsbg.png");
  background-size:cover;
  background-repeat: no-repeat;
  background-position: center center;
 
  .container {
    height: 100%;
  }
  h3 {
    font-size: 24px;
    font-weight: 600;
    line-height: 57px;
    color: rgba(255, 255, 255, 1);
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.29);
    opacity: 1;
    text-align: center;
    margin: 30px 0 30px;
  }
  .swiper-container {
    padding-bottom: 80px;
    @btn-size: 46px;
    #guests-prev,
    #guests-next {
      width: @btn-size;
      height: @btn-size;
      background-image: url("../../assets/img/pn.png");
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
      bottom: 40px;
      top: auto !important;
      position: absolute;
      cursor: pointer;
    }
    #guests-prev {
      left: 15%;
    }
    #guests-next {
      right: 15%;
      transform: rotate(180deg);
    }
    #guests-pagination {
      bottom: 36px;
      height: 17px !important;
      position: absolute;
      width: 100%;
      left: 0;
      text-align: center;
      .swiper-pagination-bullet {
        background-color: #fff;
      }
    }

    .swiper-slide {
      width: 460px;
      border-radius: 15px;
      &.swiper-slide-active {
        background: #fff;
      }
      text-align: center;
      padding: 20px;
      height: auto;
      .name {
        font-size: 20px;
        font-weight: 600;
        line-height: 40px;
        color: rgba(0, 0, 0, 1);
        opacity: 1;
        margin-top: 0px;
      }
      .job {
        font-size: 14px;
        font-weight: 400;
        line-height:28px;
        color: rgba(0, 0, 0, 1);
        opacity: 1;
        margin-top: 0px;
      }
      .detail {
        margin-top: 10px;
        font-size: 12px;
        text-align: left;
        font-weight: 400;
        height:140px;
        overflow: hidden;
        line-height: 18px;
        color: rgba(0, 0, 0, 1);
        opacity: 1;
        padding-bottom: 20px;
        
      }
      img {
        width: auto;
        height: auto;
      }
    }
  }
}
}
</style>
<style lang="less">
  #guests-pagination {
    .swiper-pagination-bullet {
      background-color: #fff;
      border-radius: 5px !important;
      height: 17px !important;
      width: 26px !important;
      opacity: 0.5 !important;
      &.swiper-pagination-bullet-active {
        // width: 210px;
        opacity: 1 !important;
      }
    }
  }
  @media (max-width: 1200px) {
    .swiper-container{
          #guests-prev {
      left: 10px;
    }
    #guests-next {
      right: 10px;
      transform: rotate(180deg);
    }
  }
   #guests-pagination {
    .swiper-pagination-bullet {
      background-color: #fff;
      border-radius: 5px !important;
      height: 14px !important;
      width: 20px !important;
      opacity: 0.5 !important;
      &.swiper-pagination-bullet-active {
        // width: 210px;
        opacity: 1 !important;
      }
    }
  }
  }
  @media (max-width: 765px) {
    
    #guests-pagination {
    .swiper-pagination-bullet {
      background-color: #fff;
      border-radius: 5px !important;
      height: 8px !important;
      width: 8px;
      opacity: 0.5 !important;
      &.swiper-pagination-bullet-active {
        width: 8px;
        opacity: 1 !important;
      }
    }
  }
  }
</style>
